import React from 'react';
import './css/index.scss';
import classnames from 'classnames';

const intended = localStorage.getItem('intended');

class LoginPage extends React.Component {

  constructor (props) {
    super(props);
    this.state = {
        showLoader: false,
        user: '',
        pass: '',
      };
  }

  render () {
    return (
      <div className="loginContainer">
        <div className="secondaryHeader"></div>
        <div className="container">
          <div className="article" style={{ marginTop: '-400px'}}>
            <h1>Autentificare</h1>
            {intended !== null ? (<p>Pentru a continua la pagina dorită vă rugăm să vă autentificați.</p>) : null}
            <div className="row">
                <div className="half">
                    <div className="login-box-page">
                        
                        <form method="post" action="" onSubmit={(event)=>{
                            event.preventDefault(); // Let's stop this event.
                            event.stopPropagation(); // Really this time.
                        }}>
                        <div>
                            {this.props.loginErrors !== null && this.props.loginErrors.email !== undefined ? <div className="error-text">{this.props.loginErrors.email.join(' ')}</div> : null}
                            <input type="text" className={classnames({'error': this.props.loginErrors !== null && this.props.loginErrors.email !== undefined})} name="taburiEmailLP" onChange={(e)=>{this.setState({user: e.target.value})}} value={this.state.user} placeholder="email" />
                        </div>
                        <div>
                            {this.props.loginErrors !== null && this.props.loginErrors.password !== undefined ? <div className="error-text">{this.props.loginErrors.password.join(' ')}</div> : null}
                            <input autoComplete="off" type="password" className={classnames({'error': this.props.loginErrors !== null && this.props.loginErrors.password !== undefined})} name="taburiPassLP" onChange={(e)=>{this.setState({pass: e.target.value})}} value={this.state.pass} placeholder="parolă" />
                        </div>
                        <div>
                           {this.props.loginErrors !== null && this.props.loginErrors.error !== undefined ? <div className="error-text-2">{this.props.loginErrors.error}</div> : null}
                            <button onClick={()=>{this.props.login(this.state.user, this.state.pass)}}>Autentificare</button>
                        </div>
                        <div>
                        <p style={{textAlign: 'center'}}>SAU dacă nu ai cont</p>
                        </div>
                        <div>
                            <button onClick={()=>{window.location = '/cont-nou';}}>Creează Cont Nou</button>
                        </div>
                        </form>
                    </div>
                </div>
                <div className="half gate">
                </div>
            </div>
           
          </div>
        </div>
      </div>
    );
  }
}

export default LoginPage;



// WEBPACK FOOTER //
// ./src/components/loginPage/loginPage.js